
import { defineComponent } from 'vue';
import BookmarkForm from '@/components/BookmarkForm.vue';
import { Bookmark } from '@/types/Bookmark';

export default defineComponent({
  name: 'Bookmark',
  components: {
    BookmarkForm,
  },
  methods: {
    saveBookmark(bookmark: Bookmark) { // for new bookmark
      const allBookmarks = this.$store.getters['bookmark/searchedBookmarks'];
      allBookmarks.push(bookmark);
      this.$store.commit('bookmark/setBookmarks', allBookmarks);
      // this.$router.push('/');
    },
  },
});
